module.exports = __webpack_public_path__ + "img/3.504714e3.jpg";